<template>
    <div class="container">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
               <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
               ~
               <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <div class="search_time search_inputBox">
               <el-date-picker v-model="start_out_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出库开始日期"></el-date-picker>
               ~
               <el-date-picker v-model="end_out_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="出库结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.order_sn" clearable placeholder="销售单号"></el-input>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.customer_id" filterable clearable placeholder="客户" @visible-change="getParamSelect">
                <el-option v-for="list in paramSelect.customers" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.salesman_id" clearable placeholder="销售人" @visible-change="getParamSelect">
                <!-- multiple collapse-tags  -->
                <el-option v-for="list in paramSelect.salesmans" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox search_inputBox_long" v-model="params.brand_id" clearable placeholder="品牌" @visible-change="getParamSelect">
                <el-option v-for="list in paramSelect.brand" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-if="isShowMore" v-model="params.breed_id" clearable placeholder="品名" @visible-change="getParamSelect">
                <el-option v-for="list in paramSelect.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox search_inputBox_long" v-if="isShowMore" v-model="params.grade_id" clearable placeholder="等级" @visible-change="getParamSelect">
                <el-option v-for="list in paramSelect.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <div class="searchBtnList clearfix">
                <!-- <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div> -->
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button class="publicBtn" @click="search">查询</el-button>
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="finance.sales.profits" :isLoading="tableLoading" :tablecol="tableCol" @rowClick="rowClick" :tabledata="list" @sortTable="sortList"></tabletem>
        </div>
        <div class="pagination_path">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="current_page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <div class="totalCal">
            <div class="totalName">合计：</div>
            <div class="totalNumber">销售毛利:{{ statistics.sales_margin }}</div>
            <div class="totalNumber">公司毛利：{{ statistics.company_margin }}</div>
            <div class="totalNumber">毛利率：{{ statistics.margin_rate }}%</div>
        </div>
        <!-- dialog START -->
            <sale-bill-base ref="saleBillBase" :dialog="dialogVisible" @hide="dialogVisible=false"
                            :dt="3" :form-data="detailInfo" :scene="'sales.order.column'" @bill="syncBill">
                <div class="editBtnList clearfix">
                    <div class="editTax clearfix">
                        <div class="editTaxname">客户欠款金额：{{bill.unbalance}}</div>
                    </div>
                    <div class="editTax clearfix" v-if="totalObj.otherFeeTotalDetail">
                        <div class="editTaxname">关联销售费用：{{totalObj.otherFeeTotalDetail}}</div>
                    </div>

                    <div class="editTax clearfix">
                        <div class="editTaxname">毛利率：{{detailInfo.margin_rate}}</div>
                    </div>
                </div>
            </sale-bill-base>
        <!-- dialog END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="finance.sales.profits" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    // dialog START
    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .bottom_flex{ padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    // dialog END
</style>
<script>
    import pagination from '../../../components/pagination.vue';
    import tabletem from '../../../components/table.vue';
    import saleBillBase from '../../../components/saleBillBase';

    const initSearchParams = {
        page : 1,
        per_page : 50,
        start_time:"",
        end_time:"",
        start_out_time:"",
        end_out_time:"",
        order_sn:"",
        customer_id:"",
        salesman_id:"",
        brand_id:"",
        breed_id:"",
        grade_id:""
    };
    export default {
        components:{
            tabletem,
            pagination,
            saleBillBase
        },
        data(){
            return{
                detailInfo: {},
                tableLoading:false,
                start_time : "",
                end_time : "",
                start_out_time:"",
                end_out_time:"",
                params:this.$cloneJson(initSearchParams),
                paramSelect:{},
                last_page : 1,
                current_page : 1,
                total:0,
                statistics : {
                    sales_margin : "",
                    company_margin : "",
                    margin_rate : ""
                },

                customerList: [],
                brandList : [],
                breedList : [],
                gradeList : [],
                saleManList : [],
                dialogVisibleRelation:false,
                list:[],
                tableCol:[
                    {colName:"单据日期",colKey:"sales_time",colWidth:128,isColor:true,isSort:true},
                    {colName:"销售单号",colKey:"order_sn",colWidth:190,isCanClick:true,isColor:true},
                    {colName:"客户",colKey:"customer_name",colWidth:111,isColor:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:85,isColor:true},
                    {colName:"件数",colKey:"count",colWidth:85,isColor:true},
                    {colName:"立方",colKey:"sales_cube",colWidth:67,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:80,isColor:true},
                    {colName:"折扣金额",colKey:"discount_amount",colWidth:80,isColor:true},
                    {colName:"应收金额",colKey:"receivable_amount",colWidth:90,isColor:true},
                    {colName:"采购金额",colKey:"purchase_amount",colWidth:80,isColor:true},
                    {colName:"成本费用",colKey:"cost_amount",colWidth:80,isColor:true},
                    {colName:"销售毛利",colKey:"margin",colWidth:80,isColor:true},
                    {colName:"销售费用",colKey:"business_expense",colWidth:80,isColor:true},
                    {colName:"优惠金额",colKey:"reduce_amount",colWidth:80,isColor:true},
                    {colName:"公司毛利",colKey:"company_margin",colWidth:80,isColor:true},
                    {colName:"毛利率",colKey:"margin_rate",colWidth:80,isColor:true},
                    {colName:"已结金额",colKey:"already_amount",colWidth:80,isColor:true},
                    {colName:"未结金额",colKey:"outstanding",colWidth:80,isColor:true},
                    {colName:"开票金额",colKey:"invoice_yes",colWidth:80,isColor:true},
                    {colName:"未开票金额",colKey:"invoice_not",colWidth:120,isColor:true},
                    {colName:"出库日期",colKey:"out_time",colWidth:120,isColor:true},
                    {colName:"结算日期",colKey:"settlement_time",colWidth:90,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:115,isColor:true},
                    {colName:"销售审核人",colKey:"auditor_name",colWidth:115,isColor:true},
                    {colName:"财务审核人",colKey:"out_auditor_name",colWidth:115,isColor:true},
                    {colName:"出库人",colKey:"out_operator_name",colWidth:115,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isColor:true},
                ],
                dialogVisible:false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                selectMap:{
                    user:[],
                    paymentType:[],
                    account:[],
                    customer:[],
                    lockLevel:[]
                },
                unbalance:"",
                bill:{},
                totalObj:{},
                // orderTypeChange:2//2新增 3修改
                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.includes("board-america"),
                boardAfricaType:localStorage.dw_erp_board.includes("board-africa"),
                categoryRawType:localStorage.dw_erp_category.includes("raw"),
                categoryBoardType:localStorage.dw_erp_category.includes("board"),
                companyName:localStorage.dw_erp_company_name,
                isShowMore:false
            }
        },
        created() {
            this.start_time = this.$getCurrentMonthStartValueOf();
            this.end_time = this.$getCurrentMonthEndtValueOf();
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
            this.getParamSelect()
            // this.getSelectList('user');
            // this.getSelectList('customer');
            this.getSelectList('account');
            // this.getSelectList('paymentType');
            // this.getSelectList('lockLevel');
        },
        methods:{
            sortList(e) {
                this.$generalSortParams(this.params, e);
                this.getList();
            },
            syncBill(e) {
                this.bill = e;
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            rowClick(obj){
                this.postFunc("/erp/finance.order",{id:obj.id},res=>{
                    let resD = res.data.data;
                    if(resD.rec_type=='DIV'){
                        resD.rec_type = 2
                    }else{
                        resD.rec_type = 1
                    }
                    this.detailInfo=this.$cloneJson(resD);
                    this.totalObj = this.detailInfo.statistic;
                    this.dialogVisible=true;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            filterConfirm(){
                this.getList()
            },
            getParamSelect(){
                this.postFunc("/erp/finance.profits.select",{},res=>{
                this.paramSelect = res.data.data;
            })
            },
            exportExcelBill(){
                this.$exportExecl("/erp/finance.profits.export","销售利润表",this.params)
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            getList(){
                this.params.start_time = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                this.params.end_time = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                this.params.start_out_time = parseInt(this.start_out_time / 1000) == 0 ? "" : parseInt(this.start_out_time / 1000);
                this.params.end_out_time = parseInt(this.end_out_time / 1000) == 0 ? "" : parseInt(this.end_out_time / 1000);
                this.tableLoading = true;
                this.$postColumnList("/erp/finance.sales.profits",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    this.list=res.data.data.list.data;
                    this.statistics = res.data.data.total;
                    this.list.forEach((item,index)=>{
                        item.margin_rate = item.margin_rate+"%";
                        if(item.sales_time!=0){
                            this.list[index].sales_time = this.formatTime(item.sales_time+"000")
                        }else{
                            this.list[index].sales_time = ""
                        }
                        if(item.out_time!=0){
                            this.list[index].out_time = this.formatTime(item.out_time+"000")
                        }else{
                            this.list[index].out_time = ""
                        }
                        if(item.settlement_time!=0){
                            this.list[index].settlement_time = this.formatTime(item.settlement_time+"000")
                        }else{
                            this.list[index].settlement_time = ""
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            search(){
                // this.params.start_time = parseInt(this.start_time / 1000) == 0 ? "" : parseInt(this.start_time / 1000);
                // this.params.end_time = parseInt(this.end_time / 1000) == 0 ? "" : parseInt(this.end_time / 1000);
                // this.params.start_out_time = parseInt(this.start_out_time / 1000) == 0 ? "" : parseInt(this.start_out_time / 1000);
                // this.params.end_out_time = parseInt(this.end_out_time / 1000) == 0 ? "" : parseInt(this.end_out_time / 1000);
                if(this.params.page == 1){
                    this.getList();
                } else {
                    this.params.page = 1
                }
            },
            reset(){
                this.start_time = "";
                this.end_time = this.$getCurrentMonthEndtValueOf();
                this.start_out_time = "";
                this.end_out_time = "";
                this.params = this.$cloneJson(initSearchParams);
                this.getList()
            }
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.search();
            },
            "dialogVisible":function(val){
                if(!val){
                    this.detailInfo = {};
                    this.bill = {};
                }
            }
        }
    }
</script>
